import { FormattedMessage } from 'react-intl'
import { Box, Grid, styled } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'
import HomeOnboardingWelcomeButton from './HomeOnboardingWelcomeButton'
import SchoolIcon from 'assets/icons/icon-school.svg?react'
import OnboardingIcon from 'assets/icons/icon-onboarding.svg?react'
import BookIcon from 'assets/icons/icon-book.svg?react'
import useOnboardingChecklist from 'features/onboarding-checklist/utils/useOnboardingChecklist'
import settings from 'settings'

const DOCUMENTATION_URL = 'https://docs.carto.com/'

const Root = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4, 0),
  borderBottom: `1px solid ${theme.palette.divider}`,
  marginBottom: theme.spacing(5),
  '& > header.MuiBox-root': {
    maxWidth: theme.spacing(94),
    marginBottom: theme.spacing(2)
  }
}))

export function HomeOnboardingWelcome() {
  const { toggleOnboardingChecklist } = useOnboardingChecklist()

  const buttons = [
    {
      icon: <OnboardingIcon />,
      title: <FormattedMessage id="home.onboarding.welcome.buttons.gettingStarted.title" />,
      description: <FormattedMessage id="home.onboarding.welcome.buttons.gettingStarted.description" />,
      onClick: (e) => {
        e.stopPropagation()
        toggleOnboardingChecklist()
      }
    },
    {
      icon: <SchoolIcon />,
      title: <FormattedMessage id="home.onboarding.welcome.buttons.accessTutorials.title" />,
      description: <FormattedMessage id="home.onboarding.welcome.buttons.accessTutorials.description" />,
      onClick: () => {
        window.open(settings.cartoAcademyUrl, '_blank')
      }
    },
    {
      icon: <BookIcon />,
      title: <FormattedMessage id="home.onboarding.welcome.buttons.documentation.title" />,
      description: <FormattedMessage id="home.onboarding.welcome.buttons.documentation.description" />,
      onClick: () => {
        window.open(DOCUMENTATION_URL, '_blank')
      }
    }
  ]

  return (
    <Root component="section">
      <Box component="header">
        <Typography mb={4} color="brand.navyBlue" variant="h4">
          <FormattedMessage id="home.onboarding.welcome.title" />
        </Typography>
        <Typography variant="body1">
          <FormattedMessage id="home.onboarding.welcome.content" />
        </Typography>
      </Box>
      <Grid width="auto" mx={-1.5} container component="footer">
        {buttons.map((button, i) => (
          <Grid item md={4} key={i}>
            <HomeOnboardingWelcomeButton {...button} />
          </Grid>
        ))}
      </Grid>
    </Root>
  )
}

export default HomeOnboardingWelcome
